import { Routes } from "../../app/router/Routes";

const prefix = (route: string) => Routes.APPLICATION + route;

export const ApplicationRoutes = {
    PERSONAL_DATA: prefix("/personal-data"),
    DETAILS: prefix("/details"),
    DATA_UPLOAD: prefix("/data-upload"),
    MOTIVATION: prefix("/motivation"),
    VERIFICATION: prefix("/verify"),
    SUCCESS: prefix("/success"),
    CODE_EXAMPLE_SUBMISSION: prefix("/:applicantId/code-example/:codingId"),
    APPOINTMENT_CONFIRMATION: prefix("/:applicantId/appointment-confirmation")
};
